import React from 'react';
import classNames from 'classnames';
import { PaintSwatches } from '@one-thd/sui-icons';
import Image from '../../common/Image';
import { paintManualImagePropTypes } from '../propTypes';

const PaintManualImage = ({ asset = null, alt = '' }) => {
  if (!asset) return null;
  const manualColorStyle = classNames(
    'manualSwatch',
    'sui-relative',
    'sui-aspect-square',
    'sui-bg-inactive',
    'sui-flex',
    'sui-items-center',
    'sui-justify-center'
  );
  return (
    <div className={manualColorStyle}>
      <div className="sui-text-center sui-flex sui-items-center sui-justify-center">
        <div>
          <PaintSwatches color="medium" />
          <div>No Color Preview Available</div>
        </div>
      </div>
      <div className="sui-w-full sui-h-auto sui-aspect-square sui-max-w-full sui-flex sui-items-end sui-absolute">
        <Image
          alt={alt}
          src={asset?.brandLogo}
        />
      </div>
    </div>
  );
};

PaintManualImage.propTypes = paintManualImagePropTypes;

export default PaintManualImage;
